// extracted by mini-css-extract-plugin
module.exports = {"phoneEntry":"styles_phoneEntry__Re1ef","phonePrefix":"styles_phonePrefix__2dQwg","phoneNumber":"styles_phoneNumber__2yO2B"};